import { withDependencies } from '@wix/thunderbolt-ioc'
import { Props, IPropsStore, StructureAPI, IStructureAPI } from '@wix/thunderbolt-symbols'
import { RichTextLinkMobileModalProps } from '@wix/thunderbolt-components-native'
import { ISiteScrollBlocker, SiteScrollBlockerSymbol } from 'feature-site-scroll-blocker'
import { enableCyclicTabbing, disableCyclicTabbing } from '@wix/thunderbolt-commons'
import { ComponentWillMount, ViewerComponent } from 'feature-components'

const richTextBoxFactory = (
	propsStore: IPropsStore,
	structureAPI: IStructureAPI,
	siteScrollBlocker: ISiteScrollBlocker
): ComponentWillMount<ViewerComponent> => {
	const openModal = async (compId: string, linkModalProps: RichTextLinkMobileModalProps) => {
		const { getEditorState, setEditorState } = linkModalProps
		const linkModalId = `linkModal_${compId}`

		enableCyclicTabbing()

		propsStore.update({
			[linkModalId]: {
				...linkModalProps,
				onClose: async () => await closeModal(compId),
				getEditorState,
				setEditorState,
			},
		})

		await structureAPI.addComponentToDynamicStructure(linkModalId, {
			componentType: 'RichTextBoxLinkModal',
			components: [],
		})

		siteScrollBlocker.setSiteScrollingBlocked(true, compId)
	}

	const closeModal = async (compId: string) => {
		const linkModalId = `linkModal_${compId}`

		await structureAPI.removeComponentFromDynamicStructure(linkModalId)

		siteScrollBlocker.setSiteScrollingBlocked(false, compId)

		disableCyclicTabbing()
	}

	return {
		componentTypes: ['RichTextBox'],
		componentWillMount(richTextBoxComp) {
			propsStore.update({
				[richTextBoxComp.id]: {
					openMobileLinkModal: (linkModalProps: RichTextLinkMobileModalProps) =>
						openModal(richTextBoxComp.id, linkModalProps),
					closeMobileLinkModal: () => closeModal(richTextBoxComp.id),
				},
			})
		},
	}
}

export const RichTextBox = withDependencies([Props, StructureAPI, SiteScrollBlockerSymbol], richTextBoxFactory)
